import React from "react";
import Navbar from "./Navbar";
import HomeNavBar from "./HomeNavBar";

function MainNavbar() {
  const token = localStorage.getItem("token");

 
  const isLoggedIn = !!token;

  return isLoggedIn ? <HomeNavBar /> : <Navbar />;
}

export default MainNavbar;